module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#magazines",
      toString: function () {
        return this.url;
      }
    }